import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgMore} from "~/assets/svg/more.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmMoreIcon: React.FC<IIconBase> = ({id, size = "md", color = designColors.black, className}) => {
  return <SvgMore id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
